import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/answer-task.action'
import * as fromLessionsActions from '../../../actions/lessons.action'
import { IAnswerTaskModel } from 'models/answerTask.model'
import answerTaskCreate from 'api/answers/task/Create'

async function createAnswerTask(data: IAnswerTaskModel) {
  return await answerTaskCreate(data)
}

function* answerOpenEndedCreateEffectSaga(action: any) {
  try {
    const { payload: { task, index } } = action
    const data = yield call(createAnswerTask, task)
    yield put(fromLessionsActions.Actions.lessonsSetAttachmentsTask({ index, data }))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* answerTaskCreateWatcherSaga() {
  yield takeLatest(fromActions.ANSWER_TASK_CREATE, answerOpenEndedCreateEffectSaga)
}
